import React from "react";
import PropTypes from "prop-types";

import "./NotFound.less";

class NotFound extends React.Component {
  componentDidMount = () => {
    this.props.history.push("/notfound");
  };
  render() {
    return <div className="notFound">NotFound</div>;
  }
}

NotFound.propTypes = {
  aString: PropTypes.string,
  anObject: PropTypes.object,
  aFunc: PropTypes.func,
  aBool: PropTypes.bool,
  anArray: PropTypes.array,
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/modules/NotFound/NotFound.js